module.exports = __webpack_public_path__ + "static/media/homeowner6-1.cebb875a.png";